import React, { ReactElement, useEffect } from 'react';
import useStyles from './styles';
import { Control, DeepMap, ErrorOption, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
// import { CanModify } from './configuration';
import { Typography } from '@material-ui/core';
import GridLayout from '../../../../components/molecules/grid_layout';
import { SchemeTypes } from '../../../../config';
import { FormFields } from '../../configuration';
import { AppCheckbox, AppSelect } from 'components/molecules/form_controls';
import * as RegistrationDetailSelectors from 'redux/reducers/registration_detail_reducer/selectors';
import CONFIGURATION, { Translations } from './configuration';
import { watch } from 'fs';
interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type: SchemeTypes;
  is_agent: boolean;
  isExcluded: boolean;
  errors: DeepMap<FormFields, FieldError>;
  control: Control<FormFields>;
  watch: (names?: string | string[]) => any;
}

export default function DeclarationsForm(props: IProps): ReactElement {
  // console.log('Render DeclarationsForm');
  const classes = useStyles();
  const mode = props.mode;
  const SCHEME_TYPE = props.scheme_type;
  const IS_AGENT = props.is_agent;
  const errors = props.errors;
  const control = props.control;
  const isExcluded = props.isExcluded;

  const watchNotEstablished = props.watch('declarations_notEstablished');

  return (
    <div>
      <Typography variant="h5">
        <TranslatedText defaultText={'Declarations'} />
      </Typography>
      <GridLayout
        elements={
          SCHEME_TYPE === SchemeTypes.NON_EU
            ? [
                {
                  element: renderNotEstablishedField(
                    errors,
                    control,
                    mode,
                    SCHEME_TYPE,
                    IS_AGENT,
                    isExcluded
                  ),
                  size: 6,
                  id: 'notEstablished',
                },
              ]
            : [
                {
                  element: renderElectronicInterfaceField(
                    errors,
                    control,
                    mode,
                    SCHEME_TYPE,
                    IS_AGENT,
                    isExcluded,
                    watchNotEstablished
                  ),
                  size: 4,
                  id: 'electronicInterface',
                },
                {
                  element: renderNotEstablishedField(
                    errors,
                    control,
                    mode,
                    SCHEME_TYPE,
                    IS_AGENT,
                    isExcluded
                  ),
                  size: 4,
                  id: 'notEstablished',
                },
                {
                  element: renderPlaceOfBusinessField(
                    errors,
                    control,
                    mode,
                    SCHEME_TYPE,
                    IS_AGENT,
                    isExcluded,
                    watchNotEstablished
                  ),
                  size: 4,
                  id: 'declarations_country_of_business_id',
                },
              ]
        }
        justify="flex-start"
      />
    </div>
  );
}

const renderElectronicInterfaceField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean,
  watchNotEstablished: boolean
) => {
  return (
    <AppCheckbox
      name="declarations_electronicInterface"
      error={'declarations_electronicInterface' in errors}
      label={<TranslatedText defaultText={'Electronic Interface'} />}
      helperText={
        errors.declarations_electronicInterface ? (
          errors.declarations_electronicInterface.message
        ) : (
          <TranslatedText defaultText={'Trade via electronic platform'} />
        )
      }
      control={control}
      rules={{
        required: watchNotEstablished
          ? 'Required Field when Not Established is selected'
          : false,
      }}
      disabled={mode === 'VIEW' || isExcluded}
    />
  );
};

const renderNotEstablishedField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean
) => {
  return (
    <AppCheckbox
      name="declarations_notEstablished"
      error={'declarations_notEstablished' in errors}
      label={<TranslatedText defaultText={'Not Established'} />}
      helperText={
        errors.declarations_notEstablished ? (
          errors.declarations_notEstablished.message
        ) : (
          <TranslatedText
            defaultText={
              'Have no Permanent Business Establishment in the Union'
            }
          />
        )
      }
      control={control}
      rules={
        SCHEME_TYPE === SchemeTypes.NON_EU ? { required: 'Required Field' } : ''
      }
      disabled={mode === 'VIEW' || isExcluded}
    />
  );
};

const renderPlaceOfBusinessField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean,
  watchNotEstablished: boolean
) => {
  let countries = RegistrationDetailSelectors.useGetCountriesNonMemberState();
  let select_countries = [];
  select_countries.push({
    id: null,
    label: 'Place Of Business',
  });
  if (countries && countries.length > 0)
    for (let country of countries)
      if (country.description !== 'CESOP')
        select_countries.push({
          id: country.country_id,
          label: country.description,
        });
  return (
    <AppSelect
      variant="outlined"
      // margin="normal"
      fullWidth
      label={<TranslatedText defaultText={'Place of Business'} />}
      id="declarations_country_of_business_id"
      name="declarations_country_of_business_id"
      required={!(mode === 'VIEW' || isExcluded || !watchNotEstablished)}
      error={'declarations_country_of_business_id' in errors}
      control={control}
      rules={
        !(mode === 'VIEW' || isExcluded || !watchNotEstablished)
          ? { required: 'Required Field' }
          : {}
      }
      options={select_countries as any}
      helperText={
        errors.contactDetails_country
          ? errors.contactDetails_country.message
          : ' '
      }
      disabled={mode === 'VIEW' || isExcluded || !watchNotEstablished}
    />
  );
};
